import type { JSX } from 'react';
import './chatbot.css';
import type { ChatbotState } from './chatbot.state';
import type { ChatbotViewModel } from './chatbot.viewmodel';
import { ChatMessageList } from './components/chat-message-list';
import { ChatInput } from './components/chat-input';

type Props = {
  state: ChatbotState;
  viewModel: Omit<ChatbotViewModel, 'state'>;
};

/**
 * Generic chatbot component.
 *
 * Renders the message list and input field. All business logic
 * is driven externally via the `ChatbotViewModel`.
 *
 * Wrap with `<ChatbotProvider>` to register custom components,
 * configure avatars, and set labels.
 */
export const Chatbot = ({ state, viewModel }: Props): JSX.Element => {
  return (
    <div className='chatbot'>
      <ChatMessageList
        messages={state.messages}
        onSelectOption={viewModel.selectOption}
        onSelectOptions={viewModel.selectOptions}
      />
      <ChatInput isDisabled={state.isInputDisabled} onSend={viewModel.sendMessage} />
    </div>
  );
};
